import { render, staticRenderFns } from "./EkpEditForm.vue?vue&type=template&id=4cc25454&scoped=true"
import script from "./EkpEditForm.vue?vue&type=script&lang=js"
export * from "./EkpEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc25454",
  null
  
)

export default component.exports